export const getQueryStringObject = (url = location.href) => {
  const { searchParams } = new URL(url);

  const queryStringObject = {
    ...Object.fromEntries(searchParams.entries()),
  };

  return queryStringObject;
};
